// Book catalog for the Tonek i Duszek shop.
// Each book has a lookup_key that matches the Stripe price catalog and a slug for its page.
export const books = [
  {
    slug: "przygoda-u-babci-pl",
    lookup_key: "book_babcia_pl",
    title: "Przygoda u Babci",
    subtitle: "Tom I — pierwsze wakacje bez rodziców",
    language: "PL",
    ageRange: "4–8 lat",
    pages: 64,
    format: "twarda oprawa · 21×24 cm",
    price_pln: 49,
    color: "#DDD6FE",
    accent: "#8B5CF6",
    cover_char: "babcia",
    tagline: "Kiedy babcina kuchnia pachnie tak, że aż chce się zostać na zawsze.",
    description:
      "Tonek i Duszek spędzają tydzień u Babci. Miedzy pierogami, opowieściami przy lampce i zaginionym kotem odkrywają, że najlepsza magia jest wieczorem, kiedy nikt się nie spieszy.",
    highlights: [
      "Miękkie, ciepłe kolory w środku",
      "Miejsce na wpisanie imienia dziecka",
      "Duża czcionka — także dla samodzielnych czytelników",
    ],
    themes: ["Rodzina", "Wieczór", "Tradycja"],
    preview_chapters: [
      "Rozdział 1: Kluczyk pod dywanikiem",
      "Rozdział 2: Kot, który się gubił specjalnie",
      "Rozdział 3: Cichy szept babcinej lampki",
    ],
    story_slug: "cichy-szept-babcinej-lampki",
  },
  {
    slug: "adventure-at-grandmas-en",
    lookup_key: "book_babcia_en",
    title: "Adventure at Grandma's",
    subtitle: "Volume I — the English edition",
    language: "EN",
    ageRange: "4–8 years",
    pages: 64,
    format: "hardcover · 21×24 cm",
    price_pln: 59,
    color: "#FEE2E2",
    accent: "#EF4444",
    cover_char: "babcia",
    tagline: "The English edition of Tonek and Little Ghost's first big trip.",
    description:
      "Tonek and Little Ghost spend a week at Grandma's house. Between dumplings, night lamp stories and a slightly-lost cat they discover that the best magic happens in the evening — when nobody's in a rush.",
    highlights: [
      "Same story, English translation",
      "Ideal for bilingual families",
      "Space to write the child's name",
    ],
    themes: ["Family", "Evening", "Bilingual"],
    preview_chapters: [
      "Chapter 1: The Key Under the Rug",
      "Chapter 2: The Cat Who Got Lost on Purpose",
      "Chapter 3: Grandma's Whispering Lamp",
    ],
    story_slug: "cichy-szept-babcinej-lampki",
  },
  {
    slug: "wycieczka-do-warszawy",
    lookup_key: "book_warszawa",
    title: "Wycieczka do Warszawy",
    subtitle: "Tom II — miasto z lotu Duszka",
    language: "PL",
    ageRange: "5–9 lat",
    pages: 72,
    format: "twarda oprawa · 21×24 cm",
    price_pln: 49,
    color: "#FDE68A",
    accent: "#F59E0B",
    cover_char: "tonek",
    tagline: "Kolej, syrenka, wielki plac. Duszek pierwszy raz widzi tramwaj.",
    description:
      "Pociągiem, tramwajem i schodami ruchomymi Tonek pokazuje Duszkowi Warszawę. Znika mu jednak balonik — a znaleźć go w wielkim mieście wcale nie jest łatwo.",
    highlights: [
      "Ilustrowana mapa Warszawy w środku",
      "Ciekawostki o pomnikach i miejscach",
      "Ukryta Syrenka w każdej ilustracji",
    ],
    themes: ["Podróże", "Miasto", "Odkrywanie"],
    preview_chapters: [
      "Rozdział 1: Pociąg pachnący przygodą",
      "Rozdział 2: Balonik w pogoni za wiatrem",
      "Rozdział 3: Syrenka po zmroku",
    ],
    story_slug: "chmura-ktora-zapomniala-padac",
  },
  {
    slug: "latajacy-wynalazek",
    lookup_key: "book_wynalazek",
    title: "Latający wynalazek",
    subtitle: "Tom III — profesor Wincent puszcza latawiec",
    language: "PL",
    ageRange: "5–10 lat",
    pages: 80,
    format: "twarda oprawa · 21×24 cm",
    price_pln: 49,
    color: "#BAE6FD",
    accent: "#0EA5E9",
    cover_char: "wincent",
    tagline: "Kiedy latawiec bardzo, bardzo chce zostać kometą.",
    description:
      "Profesor Wincent buduje latawiec, który świeci w nocy jak księżyc. Ale latawiec ma inne plany — chce polecieć wyżej niż wszystkie dachy razem wzięte.",
    highlights: [
      "Schemat latawca do sklejenia w domu",
      "Prosta lekcja fizyki dla dzieci",
      "Miejsce na własne rysunki wynalazków",
    ],
    themes: ["Nauka", "Wynalazki", "Odwaga"],
    preview_chapters: [
      "Rozdział 1: Model prototypowy 1.0",
      "Rozdział 2: Wtorkowy zmierzch",
      "Rozdział 3: Wrócił do domu",
    ],
    story_slug: "wynalazek-profesora-wincenta",
  },
  {
    slug: "piracka-wyprawa",
    lookup_key: "book_pirat",
    title: "Piracka wyprawa",
    subtitle: "Tom IV — Pirat Billy zaprasza na pokład",
    language: "PL",
    ageRange: "5–10 lat",
    pages: 80,
    format: "twarda oprawa · 21×24 cm",
    price_pln: 49,
    color: "#FCA5A5",
    accent: "#DC2626",
    cover_char: "billy",
    tagline: "Skarby, które można zabrać do kieszeni — i te ważniejsze.",
    description:
      "Pirat Billy przybija do portu z mapą i tajemnicą. Tonek, Duszek i Napoleon wypływają z nim w morze — po skarb, który tak naprawdę wcale nie jest złoty.",
    highlights: [
      "Prawdziwa mapa skarbu na wyklejce",
      "Piosenka piracka do zaśpiewania z dzieckiem",
      "Bezpieczna, ciepła wersja przygód pirackich",
    ],
    themes: ["Odwaga", "Przyjaźń", "Morze"],
    preview_chapters: [
      "Rozdział 1: Butelka z listem",
      "Rozdział 2: Wyspa, której nie było",
      "Rozdział 3: Skarb, którego nie widać",
    ],
    story_slug: "chmura-ktora-zapomniala-padac",
  },
  {
    slug: "noc-w-obserwatorium",
    lookup_key: "book_kosmos",
    title: "Noc w obserwatorium",
    subtitle: "Tom V — teleskop wielki jak marzenie",
    language: "PL",
    ageRange: "6–10 lat",
    pages: 80,
    format: "twarda oprawa · 21×24 cm",
    price_pln: 49,
    color: "#C7D2FE",
    accent: "#6366F1",
    cover_char: "robo",
    tagline: "O robocie, który uczył się patrzeć w górę.",
    description:
      "Robo-3000, Tonek i Duszek spędzają noc w obserwatorium. Uczą się, że niektóre pytania nie mają odpowiedzi — i to jest w nich najpiękniejsze.",
    highlights: [
      "Ilustrowana mapa nocnego nieba",
      "Konstelacje po polsku i angielsku",
      "Reflektorowe naklejki w środku",
    ],
    themes: ["Kosmos", "Nauka", "Wieczór"],
    preview_chapters: [
      "Rozdział 1: Herbata dla robota",
      "Rozdział 2: 4127 punktów świetlnych",
      "Rozdział 3: Zgadzasz się",
    ],
    story_slug: "robo-3000-i-noc-pelna-gwiazd",
  },
  {
    slug: "robot-z-gwiazd",
    lookup_key: "book_robo",
    title: "Robot z gwiazd",
    subtitle: "Tom VI — Robo-3000 się zakochuje w chmurach",
    language: "PL",
    ageRange: "6–10 lat",
    pages: 80,
    format: "twarda oprawa · 21×24 cm",
    price_pln: 49,
    color: "#A5B4FC",
    accent: "#4F46E5",
    cover_char: "robo",
    tagline: "Serce robota jest z metalu — ale bije tak samo.",
    description:
      "Robo-3000 spada z nieba do ogrodu Babci. Uczy się, co znaczy „za późno na obiad” i dlaczego psy się cieszą, kiedy wracasz. Nawet, jeśli byłeś tylko pół godziny.",
    highlights: [
      "Prosty słowniczek emocji",
      "Rozdział z pytaniami dla dziecka",
      "Wersja dla najmłodszych do słuchania",
    ],
    themes: ["Emocje", "Przyjaźń", "Technologia"],
    preview_chapters: [
      "Rozdział 1: Alarm w rabatce",
      "Rozdział 2: Herbata w metalowej dłoni",
      "Rozdział 3: Folder ważne",
    ],
    story_slug: "robo-3000-i-noc-pelna-gwiazd",
  },
  {
    slug: "kolekcja-3-ksiazek",
    lookup_key: "book_kolekcja",
    title: "Kolekcja: 3 książki",
    subtitle: "Wybierz sam trzy tomy w prezencie",
    language: "PL",
    ageRange: "4–10 lat",
    pages: "3 × 64–80",
    format: "3 książki w opakowaniu prezentowym",
    price_pln: 139,
    color: "#FDE68A",
    accent: "#F59E0B",
    cover_char: "duszek",
    tagline: "Prezent, po którym dziecko nie wypuszcza z rąk pudełka.",
    description:
      "Trzy dowolne tomy w twardej oprawie w papierowym pudełku z uchwytem. Idealne na urodziny, święta, „chcę zrobić dziś coś dobrego”.",
    highlights: [
      "Oszczędzasz 8 zł względem kupowania osobno",
      "Pudełko z uchwytem do niesienia",
      "Wybór tomów podasz w formularzu zamówienia",
    ],
    themes: ["Prezent", "Kolekcja"],
    preview_chapters: ["Rozdziały z 3 dowolnych tomów"],
    story_slug: null,
  },
];

export const getBookBySlug = (slug) => books.find((b) => b.slug === slug);
export const getBookByLookupKey = (key) => books.find((b) => b.lookup_key === key);
